<template>
    <div class="search-bar">
        <!-- <img src="../../assets/img/icon/search_gray.svg" alt="">
        <input type="text" placeholder="搜尋" v-model="searchQuery" @keyup="clickSearch"> -->
    </div>
</template>
<script>
export default {
    name: 'SearchBar',
    data () {
        return {
            searchQuery: '',
        }
    },
    props: {
        recentSearch: {
            type: Array,
            // required: true
        },
        newSearchQuery: {
            type: String
            // required: true
        }
    },
    methods: {
        clickSearch () {
            // this.$emit('clickSearch', this.searchQuery)
        },
        clickClearSearch () {
            this.searchQuery = ''
        }
    }
}
</script>
<style scoped lang="scss">
    .search-bar{
        display: flex;
        align-items: center;
        margin-left: 38px;
        margin-right: 224px;
        width: 810px;
        input{
            border: 0px;
            width: 800px;
        }
    }
    @media screen and (max-width: 1280px) {
        .search-bar{
            margin-right: 195px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/SearchBar.vue